// Mirrors canReassign in routes/reassign.js: admins plus GV (decision 27 Oct 2026). The server
// enforces it; this only decides whether to show the controls.
const REASSIGN_EXTRA_EMAILS = ['gv@mountainrecruiting.com'];

export default function canReassign(user) {
  return user?.role?.toLowerCase() === 'admin' || REASSIGN_EXTRA_EMAILS.includes(String(user?.email || '').toLowerCase());
}
